import { DateTimeStr, Timestamp } from '@mi-front/core';
import mime from 'mime';
import moment from 'moment';

export function mimeType(filename: string) {
  return mime.getType(filename);
}

export function ellipsis(text: string, maxLength = 30): string {
  if (text.length > maxLength) {
    text = text.slice(0, maxLength) + '...';
  }

  return text;
}

export function round(num: number, decimalPlaces = 0) {
  const rounded = Math.round(Number(`${num}e${decimalPlaces}`));

  return Number(`${rounded}e${-decimalPlaces}`);
}

export function videoToImage(el: HTMLVideoElement): string {
  const canvas = document.createElement('canvas');
  canvas.width = el.videoWidth;
  canvas.height = el.videoHeight;

  const context = canvas.getContext('2d');

  if (context) {
    context.drawImage(el, 0, 0, canvas.width, canvas.height);
  }

  return canvas.toDataURL('image/png', 0.1);
}

export function debugTime(time: number | string | DateTimeStr | Timestamp | Date) {
  return moment(time).format('HH:mm:ss.SSS');
}
